import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import styleGrid from '../../blocks/grid/style.pcss';
import { check, uncheck } from '../checked/actions';

import { deleteEvent } from './actions';

import style from './style.pcss';

const classnames = classNames.bind(style);

@connect((state) => ({
    tournaments: state.tournaments.items,
    searchEvent: state.tournaments.isSearchEvent,
    isLoaded   : state.tournaments.isLoaded,
    gameId     : state.sports.selected,
    sports     : state.sports.items,
    checked    : state.checked.items
}), (dispatch) => ({
    dispatchDeleteEvent: (params) => dispatch(deleteEvent(params)),
    dispatchUncheck    : (params) => dispatch(uncheck(params)),
    dispatchCheck      : (params) => dispatch(check(params))
}))
class Tournaments extends Component {

    static displayName = '[block] tournaments';

    static propTypes = {
        tournaments: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        gameId             : PropTypes.number,
        dispatchDeleteEvent: PropTypes.func,
        dispatchUncheck    : PropTypes.func,
        dispatchCheck      : PropTypes.func,
        checked            : PropTypes.object,
        searchEvent        : PropTypes.bool,
        sports             : PropTypes.array
    };

    selectTournament = (gameId, tournament) => (e) => {
        const { searchEvent, tournaments, sports, dispatchUncheck, dispatchCheck } = this.props;
        const sport = !searchEvent ? sports.find((sport) => sport._id === gameId) : { gameId: tournament.gameId };

        if(e.currentTarget.checked) {
            dispatchCheck({
                kind: 'tournaments',
                sport,
                tournament
            })
        } else {
            dispatchUncheck({
                kind             : 'tournaments',
                globalTournaments: tournaments,
                sport,
                tournament
            })
        }

        e.stopPropagation();
    };

    delete = (event) => (e) => {
        e.preventDefault();

        const { tournaments, dispatchUncheck, dispatchDeleteEvent, checked } = this.props;

        dispatchDeleteEvent(event);

        if(checked[event.gameId] && checked[event.gameId].includes(event._id)) {
            dispatchUncheck({
                kind             : 'tournaments',
                globalTournaments: tournaments,
                sport            : { gameId: event.gameId },
                tournament       : event
            });
        }
    };

    render() {
        const { gameId, checked, tournaments, searchEvent, isLoaded, sports } = this.props;
        const listTournaments = searchEvent ? tournaments : tournaments[gameId];

        return (
            <div className={styleGrid['grid__main-tournaments']}>
                <div className={style['tournaments__scrollable']}>
                    {isLoaded && sports.length ? (
                        <Droppable droppableId="tournaments" type="TOURNAMENTS">
                            {(provided) => (
                                <div className={style['tournaments__content']} ref={provided.innerRef}>
                                    {listTournaments.length ? listTournaments.map((item, index) => {
                                        const checkedGameId = checked[!searchEvent ? gameId : item.gameId];

                                        return (
                                            <Draggable key={item._id || item.positionId} draggableId={item._id} index={index} type="TOURNAMENTS" isDragDisabled={searchEvent}>
                                                {(provided) => (
                                                    <div>
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={classnames('tournaments__item', {
                                                                tournaments__item_odd: index % 2 !== 0 // eslint-disable-line camelcase
                                                            })}
                                                        >
                                                            <input
                                                                className={style['tournaments__checkbox']}
                                                                type="checkbox"
                                                                onChange={this.selectTournament(gameId, item)}
                                                                checked={checkedGameId && Array.isArray(checkedGameId) && checkedGameId.indexOf(item._id) !== -1 || checkedGameId && !Array.isArray(checkedGameId) || false}
                                                            />
                                                            <span className={style['tournaments__label']}>{item.category}. {item.tournamentTitle} {item.title}</span>
                                                            {searchEvent ? (
                                                                <button onClick={this.delete(item)} className={style['tournaments__delete']} />
                                                            ) : (
                                                                <span className={style['tournaments__amount']}>{item.total}</span>
                                                            )}
                                                        </div>
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    }) : null}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    ) : null}

                </div>
            </div>
        )
    }

}

export default Tournaments;



// WEBPACK FOOTER //
// ./src/blocks/tournaments/index.js